// extracted by mini-css-extract-plugin
export default {"brick-layout":"BrickLayout_brick-layout__5eVdq","brick-column":"BrickLayout_brick-column__ckk9b"};